__turbopack_context__.v({
  "arrow": "Navbar-module__cnpACG__arrow",
  "container": "Navbar-module__cnpACG__container",
  "dropdown": "Navbar-module__cnpACG__dropdown",
  "dropdownItem": "Navbar-module__cnpACG__dropdownItem",
  "dropdownItemIcon": "Navbar-module__cnpACG__dropdownItemIcon",
  "dropdownVisible": "Navbar-module__cnpACG__dropdownVisible",
  "logo": "Navbar-module__cnpACG__logo",
  "logoImage": "Navbar-module__cnpACG__logoImage",
  "navItem": "Navbar-module__cnpACG__navItem",
  "navLink": "Navbar-module__cnpACG__navLink",
  "navLinkActive": "Navbar-module__cnpACG__navLinkActive",
  "navList": "Navbar-module__cnpACG__navList",
  "navbar": "Navbar-module__cnpACG__navbar",
  "rightActions": "Navbar-module__cnpACG__rightActions",
});
